import { useCallback, useEffect, useState } from 'react';
import { scrollIntoView } from 'seamless-scroll-polyfill';

import { useRequestAnimationFrame } from '.';

type State = { top?: boolean; bottom?: boolean };

const useScrollHandler = (top: HTMLElement | null, bottom: HTMLElement | null) => {
  const [state, setState] = useState<State>({});

  useRequestAnimationFrame();

  const scrollDown = useCallback(
    (smooth: boolean = true) => {
      if (bottom) {
        scrollIntoView(bottom, {
          behavior: smooth ? 'smooth' : undefined,
          block: 'end',
          inline: 'nearest',
        });
      }
    },
    [bottom]
  );

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        for (const entry of entries) {
          const target = entry.target === top ? 'top' : 'bottom';
          setState(state => ({ ...state, [target]: entry.isIntersecting }));
        }
      },
      { threshold: 0.5 }
    );

    if (top) {
      observer.observe(top);
    }

    if (bottom) {
      observer.observe(bottom);
    }

    return () => observer.disconnect();
  }, [bottom, top]);

  return { ...state, scrollDown };
};

export default useScrollHandler;
